import Vue from 'vue'
import Vuex from 'vuex'
import snackbar from './modules/snackbar.js'
import overlay from './modules/overlay.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    snackbar: snackbar,
    overlay: overlay
  }
})
